export default __webpack_public_path__ + "static/media/conference-hall-2.db529e77.jpg";